'use client';

import { createContext, useContext, useState, ReactNode } from "react";

export type HeaderTheme = "dark" | "light";

type NavigationContextType = {
  // controle de etapas
  currentStep: number;
  nextStep: () => void;
  prevStep: () => void;
  goToStep: (step: number) => void;

  // controle de tema do cabeçalho
  headerTheme: HeaderTheme;
  setHeaderTheme: (theme: HeaderTheme) => void;
};

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider = ({ children }: { children: ReactNode }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [headerTheme, setHeaderTheme] = useState<HeaderTheme>("light");

  const nextStep = () => setCurrentStep((s) => s + 1);
  const prevStep = () => setCurrentStep((s) => Math.max(s - 1, 0));
  const goToStep = (step: number) => setCurrentStep(step);

  return (
    <NavigationContext.Provider
      value={{
        currentStep,
        nextStep,
        prevStep,
        goToStep,
        headerTheme,
        setHeaderTheme,
      }}
    >
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigation must be used within a NavigationProvider");
  }
  return context;
};
